import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import styles from './footer.module.scss';
import { FacebookIcon } from './icon/facebook-icon';
import { PhoneIcon } from './icon/phone-icon';
import { WhatsappIcon } from './icon/whatsapp-icon';
import { useLang, useLocalize } from './localize-context';
import { NavLink } from './nav-link';
import { OutLink } from './outlink';

export const Footer = () => {
  const { footer, products } = useStaticQuery(query);
  const lang = useLang();
  const localize = useLocalize();
  const footerData = footer.nodes.find(node => node.lang === lang);
  const productPages = products.nodes.filter(node => node.lang === lang);

  return (
    <footer className="pt-12 pb-8 sm:pb-16 bg-blue-500 text-gray-100">
      <div className="max-w-6xl mx-auto px-3 sm:px-6">
        <nav className="text-lg pb-4">
          <ul className="sm:flex flex-wrap">
            <li className="pb-4 mr-6">
              <NavLink to="/package">{localize('Packages')}</NavLink>
            </li>
            <li className="pb-4 mr-6">
              <NavLink to="/combo">{localize('Combo')}</NavLink>
            </li>
            <li className="pb-4 mr-6">
              <NavLink to="/itinerary">{localize('Itinerary')}</NavLink>
            </li>
            <li className="pb-4 mr-6">
              <NavLink to="/rate">{localize('Rates')}</NavLink>
            </li>
            <li className="pb-4 mr-6">
              <NavLink to="/reminder">{localize('Reminders')}</NavLink>
            </li>
            <li className="pb-4 mr-6">
              <NavLink to="/album">{localize('Album')}</NavLink>
            </li>
            <li className="pb-4 mr-6">
              <NavLink to="/schedule">{localize('Departure Time')}</NavLink>
            </li>
            {productPages.map(productPage => (
              <li className="pb-4 mr-6" key={productPage.uid}>
                <NavLink to={`/${productPage.uid}`}>
                  {productPage.data.title.text}
                </NavLink>
              </li>
            ))}
            <li className="pb-4 mr-6">
              <NavLink to="/mco-registration">
                {localize('MCO Registration')}
              </NavLink>
            </li>
          </ul>
        </nav>
        {footerData && (
          <>
            <div className="md:flex justify-between items-start">
              <div
                className="mb-6 flex-1 rich-text"
                dangerouslySetInnerHTML={{
                  __html: footerData.data.business.html,
                }}
              />
              <div className="flex mb-6">
                {footerData.data.phone && (
                  <OutLink to={`tel:${footerData.data.phone.text}`}>
                    <PhoneIcon />
                  </OutLink>
                )}
                {footerData.data.whatsapp && (
                  <OutLink
                    to={`https://wa.me/${footerData.data.whatsapp.text}`}
                    className="ml-4"
                  >
                    <WhatsappIcon className="shadow" />
                  </OutLink>
                )}
                {footerData.data.fb && (
                  <OutLink
                    to={footerData.data.fb.url}
                    target={footerData.data.fb.target}
                    className="ml-4"
                  >
                    <FacebookIcon />
                  </OutLink>
                )}
              </div>
            </div>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: footerData.data.description.html,
              }}
            />
          </>
        )}
        <p>
          {currentYear} &copy; {localize('All Rights Reserved')}
        </p>
      </div>
    </footer>
  );
};

const currentYear = new Date().getFullYear();

const query = graphql`
  {
    footer: allPrismicFooter {
      nodes {
        lang
        data {
          phone: contact_number {
            text
          }
          business: business_details {
            html
          }
          description {
            html
          }
          fb: facebook_page_url {
            url
            target
          }
          whatsapp: whatsapp_number {
            text
          }
        }
      }
    }
    products: allPrismicProductPage {
      nodes {
        uid
        lang
        data {
          title {
            text
          }
        }
      }
    }
  }
`;
